import React from "react";
import useUserAgent from "../../../hooks/useUserAgent.js";
import { UnifiedPriceTagPriceBreakdownMobile } from "./UnifiedPriceTagPriceBreakdown.mobile.js";
import { UnifiedPriceTagPriceBreakdownDesktop } from "./UnifiedPriceTagPriceBreakdown.desktop.js";
export const UnifiedPriceTagPriceBreakdown = (props) => {
    const { isMobile } = useUserAgent();
    return isMobile ? (React.createElement(UnifiedPriceTagPriceBreakdownMobile, { ...props })) : (React.createElement(UnifiedPriceTagPriceBreakdownDesktop, { ...props }));
};
